document.documentElement.classList.remove('no-js');

class DuaTheme {
  constructor(){
    this.bindMobileMenu();
    this.bindGalleries();
    this.bindVariantPills();
    this.bindQuantitySteppers();
    this.bindProductForms();
    this.bindFooterAccordions();
    this.bindCartDrawer();
  }

  money(cents){
    return 'Rs.' + Math.round(Number(cents || 0) / 100).toLocaleString('en-PK');
  }

  escapeHtml(value=''){
    return String(value).replace(/[&<>"']/g,(ch)=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch]));
  }

  bindMobileMenu(){
    document.querySelectorAll('.mobile-menu a').forEach((link)=>{
      if(link.dataset.yBound) return;
      link.dataset.yBound='1';
      link.addEventListener('click',()=>{
        const details=link.closest('details');
        if(details) details.removeAttribute('open');
      });
    });
  }

  bindGalleries(){
    document.querySelectorAll('[data-y-gallery]').forEach((gallery)=>{
      if(gallery.dataset.yGalleryBound) return;
      gallery.dataset.yGalleryBound='1';
      const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
      const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
      const current=gallery.querySelector('[data-gallery-current]');
      if(!slides.length) return;
      let index=Math.max(0,slides.findIndex(s=>s.classList.contains('is-active')));
      const show=(next)=>{
        index=(next+slides.length)%slides.length;
        slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));
        thumbs.forEach((thumb,i)=>{
          thumb.classList.toggle('is-active',i===index);
          thumb.setAttribute('aria-selected',i===index?'true':'false');
        });
        if(current) current.textContent=String(index+1);
      };
      gallery._yShowMedia=(mediaId)=>{
        if(!mediaId) return;
        const target=slides.findIndex(slide=>String(slide.dataset.mediaId)===String(mediaId));
        if(target>=0) show(target);
      };
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(index-1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(index+1));
      thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
      let startX=null;
      gallery.querySelector('.gallery-main')?.addEventListener('touchstart',(e)=>{startX=e.touches[0].clientX;},{passive:true});
      gallery.querySelector('.gallery-main')?.addEventListener('touchend',(e)=>{
        if(startX===null) return;
        const delta=e.changedTouches[0].clientX-startX;
        if(Math.abs(delta)>45) show(delta<0?index+1:index-1);
        startX=null;
      },{passive:true});
      show(index);
    });
  }

  bindVariantPills(){
    document.querySelectorAll('[data-y-product-form]').forEach((form)=>{
      if(form.dataset.yVariantBound) return;
      form.dataset.yVariantBound='1';
      const pills=[...form.querySelectorAll('[data-y-variant-pill]')];
      const variantInput=form.querySelector('[data-y-variant-input]');
      const scope=form.closest('.product-info') || form.closest('[data-product-section]') || document;
      const price=scope.querySelector('[data-y-product-price]');
      const compare=scope.querySelector('[data-y-compare-price]');
      const save=scope.querySelector('[data-y-save-badge]');
      const addButton=form.querySelector('[data-y-add-button]');
      const gallery=form.closest('[data-product-section]')?.querySelector('[data-y-gallery]');
      const activate=(pill)=>{
        if(!pill || pill.disabled) return;
        pills.forEach(p=>{
          const active=p===pill;
          p.classList.toggle('is-active',active);
          p.setAttribute('aria-pressed',active?'true':'false');
        });
        if(variantInput) variantInput.value=pill.dataset.variantId;
        if(price && pill.dataset.price) price.textContent=pill.dataset.price;

        const compareText=pill.dataset.comparePrice || '';
        const savePercent=parseInt(pill.dataset.savePercent || '0',10) || 0;
        if(compare){
          compare.textContent=compareText;
          compare.classList.toggle('is-hidden',!compareText);
        }
        if(save){
          save.textContent=savePercent>0 ? 'SAVE '+savePercent+'%' : '';
          save.classList.toggle('is-hidden',savePercent<=0);
        }

        const available=pill.dataset.available==='true';
        if(addButton){
          addButton.disabled=!available;
          const label=addButton.dataset.baseLabel || addButton.textContent.split('•')[0].trim() || 'Add to Cart';
          addButton.dataset.baseLabel=label;
          addButton.textContent=available?(label+' • '+(pill.dataset.price||'')).trim():'Currently Unavailable';
        }
        if(gallery && pill.dataset.mediaId && typeof gallery._yShowMedia==='function') gallery._yShowMedia(pill.dataset.mediaId);
        try{
          const url=new URL(window.location.href);
          url.searchParams.set('variant',pill.dataset.variantId);
          window.history.replaceState({},'',url);
        }catch(e){}
      };
      pills.forEach(pill=>pill.addEventListener('click',()=>activate(pill)));
      const selected=pills.find(p=>p.classList.contains('is-active'));
      if(selected) activate(selected);
    });
  }

  bindQuantitySteppers(){
    document.querySelectorAll('[data-y-quantity]').forEach((stepper)=>{
      if(stepper.dataset.yQuantityBound) return;
      stepper.dataset.yQuantityBound='1';
      const input=stepper.querySelector('input[name="quantity"]');
      if(!input) return;
      const set=(value)=>{
        const min=parseInt(input.min||'1',10);
        const max=input.max?parseInt(input.max,10):999;
        input.value=Math.min(max,Math.max(min,parseInt(value||min,10)||min));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      };
      stepper.querySelector('[data-qty-minus]')?.addEventListener('click',()=>set(parseInt(input.value||'1',10)-1));
      stepper.querySelector('[data-qty-plus]')?.addEventListener('click',()=>set(parseInt(input.value||'1',10)+1));
      input.addEventListener('change',()=>set(input.value));
    });
  }

  bindProductForms(){
    document.querySelectorAll('form[action*="/cart/add"], [data-y-product-form]').forEach((form)=>{
      if(form.dataset.yAjaxBound) return;
      form.dataset.yAjaxBound='1';
      form.addEventListener('submit',async(event)=>{
        if(!window.fetch) return;
        event.preventDefault();
        if(form.dataset.yAdding==='1') return;
        form.dataset.yAdding='1';
        const button=form.querySelector('[data-y-add-button]') || form.querySelector('[name="add"]');
        const oldText=button?button.textContent:'';
        if(button){button.disabled=true;button.textContent='Adding…';}
        try{
          const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{
            method:'POST',
            headers:{'Accept':'application/json'},
            body:new FormData(form)
          });
          if(!response.ok){
            const detail=await response.json().catch(()=>({}));
            throw new Error(detail.description || 'Unable to add item');
          }
          await response.json();
          const cart=await this.fetchCart();
          this.updateCartCount(cart.item_count);
          this.renderCartDrawer(cart);
          this.openCartDrawer(button);
          if(button){button.textContent='Added ✓';setTimeout(()=>{if(button.textContent==='Added ✓') button.textContent=oldText;},1000);}
        }catch(error){
          if(button){button.textContent='Try again';setTimeout(()=>{if(button.textContent==='Try again') button.textContent=oldText;},2500);}
          const status=form.querySelector('[data-cart-add-status]');
          if(status) status.textContent=error.message;
        }finally{
          form.dataset.yAdding='0';
          if(button) button.disabled=false;
        }
      });
    });
  }

  bindFooterAccordions(){
    const mq=window.matchMedia('(min-width:768px)');
    const sync=()=>{
      document.querySelectorAll('.y-footer-details').forEach((details)=>{
        if(mq.matches) details.setAttribute('open','');
        else details.removeAttribute('open');
      });
    };
    sync();
    if(!document.documentElement.dataset.yFooterMediaReady){
      document.documentElement.dataset.yFooterMediaReady='1';
      if(typeof mq.addEventListener==='function') mq.addEventListener('change',sync);
      else mq.addListener(sync);
    }
  }

  bindCartDrawer(){
    const drawer=document.querySelector('[data-y-cart-drawer]');
    if(!drawer || drawer.dataset.yBound) return;
    drawer.dataset.yBound='1';

    document.querySelectorAll('.y-header-cart').forEach((link)=>{
      if(link.dataset.yDrawerBound) return;
      link.dataset.yDrawerBound='1';
      link.addEventListener('click',async(event)=>{
        if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey) return;
        event.preventDefault();
        try{
          const cart=await this.fetchCart();
          this.renderCartDrawer(cart);
          this.openCartDrawer(link);
        }catch(error){window.location.href=link.href;}
      });
    });

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(el=>el.addEventListener('click',()=>this.closeCartDrawer()));
    document.addEventListener('keydown',(e)=>{ if(e.key==='Escape' && drawer.classList.contains('is-open')) this.closeCartDrawer(); });

    drawer.addEventListener('click',async(event)=>{
      const minus=event.target.closest('[data-drawer-minus]');
      const plus=event.target.closest('[data-drawer-plus]');
      const remove=event.target.closest('[data-drawer-remove]');
      if(!minus&&!plus&&!remove) return;
      const row=event.target.closest('[data-cart-item-key]');
      if(!row) return;
      const key=row.dataset.cartItemKey;
      const quantity=parseInt(row.dataset.quantity||'1',10);
      let next=quantity;
      if(minus) next=Math.max(0,quantity-1);
      if(plus) next=quantity+1;
      if(remove) next=0;
      if(row.dataset.updating==='1') return;
      row.dataset.updating='1';
      try{await this.changeCart(key,next);}catch(error){row.dataset.updating='0';}
    });
    drawer.querySelector('[data-cart-drawer-checkout]')?.addEventListener('click',(event)=>{
      if(event.currentTarget.getAttribute('aria-disabled')==='true') event.preventDefault();
    });
    drawer.addEventListener('keydown',(event)=>{
      if(event.key!=='Tab') return;
      const focusable=[...drawer.querySelectorAll('a[href], button:not([disabled])')].filter(el=>el.getClientRects().length);
      if(!focusable.length) return;
      if(event.shiftKey && document.activeElement===focusable[0]){event.preventDefault();focusable.at(-1).focus();}
      else if(!event.shiftKey && document.activeElement===focusable.at(-1)){event.preventDefault();focusable[0].focus();}
    });
  }

  async fetchCart(){
    const root=(window.Shopify?.routes?.root||'/');
    const response=await fetch(root+'cart.js',{headers:{'Accept':'application/json'}});
    if(!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  async changeCart(key,quantity){
    const root=(window.Shopify?.routes?.root||'/');
    const response=await fetch(root+'cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity})
    });
    if(!response.ok) return;
    const cart=await response.json();
    this.updateCartCount(cart.item_count);
    this.renderCartDrawer(cart);
  }

  updateCartCount(count){
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=count);
  }

  openCartDrawer(opener=document.activeElement){
    const drawer=document.querySelector('[data-y-cart-drawer]');
    if(!drawer) return;
    this.cartDrawerOpener=opener;
    drawer.hidden=false;
    requestAnimationFrame(()=>drawer.classList.add('is-open'));
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('y-cart-drawer-open');
    document.documentElement.classList.add('y-cart-drawer-open');
    drawer.querySelector('.y-cart-drawer__close')?.focus();
  }

  closeCartDrawer(){
    const drawer=document.querySelector('[data-y-cart-drawer]');
    if(!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('y-cart-drawer-open');
    document.documentElement.classList.remove('y-cart-drawer-open');
    this.cartDrawerOpener?.focus?.();
    setTimeout(()=>{ if(!drawer.classList.contains('is-open')) drawer.hidden=true; },250);
  }

  renderCartDrawer(cart){
    const drawer=document.querySelector('[data-y-cart-drawer]');
    if(!drawer) return;
    const body=drawer.querySelector('[data-cart-drawer-items]');
    const count=drawer.querySelector('[data-cart-drawer-count]');
    const subtotal=drawer.querySelector('[data-cart-drawer-subtotal]');
    const savingsRow=drawer.querySelector('[data-cart-drawer-savings-row]');
    const savings=drawer.querySelector('[data-cart-drawer-savings]');
    const shipping=drawer.querySelector('[data-cart-drawer-shipping]');
    const checkout=drawer.querySelector('[data-cart-drawer-checkout]');

    if(count) count.textContent=cart.item_count;
    if(subtotal) subtotal.textContent=this.money(cart.total_price);
    const savingValue=Math.max(0,(cart.original_total_price||cart.total_price)-cart.total_price);
    if(savingsRow) savingsRow.hidden=savingValue<=0;
    if(savings) savings.textContent='−'+this.money(savingValue);
    if(shipping){
      shipping.textContent='Shipping calculated at checkout';
      shipping.classList.remove('is-free');
    }
    if(checkout){
      checkout.classList.toggle('is-disabled',cart.item_count===0);
      checkout.setAttribute('aria-disabled',cart.item_count===0?'true':'false');
      checkout.tabIndex=cart.item_count===0?-1:0;
    }

    if(!body) return;
    if(!cart.items?.length){
      body.innerHTML='<div class="y-cart-drawer__empty"><strong>Your cart is empty.</strong><p>Explore the Dua Skin Care collection.</p><a href="/collections/all">Shop all products</a></div>';
      return;
    }

    body.innerHTML=cart.items.map((item)=>{
      const img=item.featured_image?.url || item.image || '';
      const variant=item.variant_title && item.variant_title!=='Default Title' ? '<span class="y-cart-drawer__variant">'+this.escapeHtml(item.variant_title)+'</span>' : '';
      const discount=item.original_line_price>item.final_line_price ? '<span class="y-cart-drawer__old-price">'+this.money(item.original_line_price)+'</span>' : '';
      return '<article class="y-cart-drawer__item" data-cart-item-key="'+this.escapeHtml(item.key)+'" data-quantity="'+item.quantity+'">'+
        '<a class="y-cart-drawer__image" href="'+this.escapeHtml(item.url)+'">'+(img?'<img src="'+this.escapeHtml(img)+'" alt="'+this.escapeHtml(item.product_title)+'">':'')+'</a>'+
        '<div class="y-cart-drawer__meta"><a class="y-cart-drawer__title" href="'+this.escapeHtml(item.url)+'">'+this.escapeHtml(item.product_title)+'</a>'+variant+
          '<div class="y-cart-drawer__qty"><button type="button" data-drawer-minus aria-label="Decrease quantity">−</button><span>'+item.quantity+'</span><button type="button" data-drawer-plus aria-label="Increase quantity">+</button></div>'+
        '</div>'+
        '<div class="y-cart-drawer__price">'+discount+'<strong>'+this.money(item.final_line_price)+'</strong><button type="button" data-drawer-remove aria-label="Remove '+this.escapeHtml(item.product_title)+'">Remove</button></div>'+
      '</article>';
    }).join('');
  }
}

document.addEventListener('DOMContentLoaded',()=>new DuaTheme());
document.addEventListener('shopify:section:load',()=>new DuaTheme());
